<script>
	
	import {onMount} from "svelte";
	import {readExcelFile} from "../../../../../services/readExcelFile";
	import { addBacthData } from "../../../../../api/Batch";
	import { saveAs } from "file-saver";


	export let newBatchOpen = true;

	let productsArray = null;

	let productSelected = 'Select';

	let fileTypeSelected = 'Select';

	let dataType = 'Select';

	let file = null;

	var batchData = null;

	var wasFileDownloaded = true;

	let resExcelFile = null;


	onMount(() => {

		var company = localStorage.getItem('company');
		company = JSON.parse(company);		
		productsArray = company.Products;

		productsArray = productsArray;
	
	});


	async function sendBatchDataToDB(data){

		const res = await addBacthData(data);

		return res;
	}

	async function getFile(e){

		
		file = e.target.files[0];

		var data = {
			product: productSelected,
			dataType: dataType
		}
		
		resExcelFile = await readExcelFile(file, data);
        
        if(resExcelFile.status == 'valid'){
        	
        	batchData = {};
        	batchData.data = resExcelFile.data;
        	
        	// console.log(resExcelFile.errorLog.Microbiology.length);

        	if(resExcelFile.errorLog.Microbiology.length != 0 || resExcelFile.errorLog.Nutritional.length != 0 ){
        		//download error file log
        		alert('Errors found on imported file, check the log error file to know more!');

        		var buffer = 'Error log:\n\n';

        		buffer = buffer + 'Microbiology Sheet: \n';

        		for(let i = 0 ; i < resExcelFile.errorLog.Microbiology.length ; i++){

        			buffer = buffer + resExcelFile.errorLog.Microbiology[i] + '\n'; 
        		}

        		buffer = buffer + 'Nutritional Sheet: \n';

        		for(let i = 0 ; i < resExcelFile.errorLog.Microbiology.length ; i++){

        			buffer = buffer + resExcelFile.errorLog.Nutritional[i] + '\n'; 
        		}
       			var blob = new Blob([buffer], { type: "application/txt" });
    			saveAs(blob, "logError.txt");
        	}

        }
        else if(resExcelFile.status == 'error'){
        	alert('Error reading file!');
        }
		
	}

	async function submitDataFromFile(){

		if(file != null && batchData != null){

			var dbRes =  await sendBatchDataToDB(batchData);


			if(dbRes.status == "valid"){

				// data correctly sent to DB
				// return to table view

				if(dbRes.info.length > 0){

					let newMsg = 'You tried to import'+' '+ dbRes.info.length +' '+'Batches that have a BatchID already in use in the database, check the log error file.';

					alert(dbRes.message + ' ' + newMsg);
				}
				else{
					alert(dbRes.message);	
				}
				

				// newBatchOpen = false;
			}
			else if(dbRes.status == "error"){

				//Failed to load data
				//warning message 
				//Ask for try again
				alert(dbRes.error);
			}
		}

	}

	function downloadFunc(){


    	var anchor=document.createElement('a');

    	if(dataType == 'Mean'){
    		anchor.setAttribute('href','/typeFiles/Mean/Mean_ArtisaneFileModel.xlsx');
    	}
    	else if(dataType == 'Individual'){
    		anchor.setAttribute('href','/typeFiles/Individual/Individual_ArtisaneFileModel.xlsx');
    	}
    	else{
    		//error
    	}

    	anchor.setAttribute('download','');
    	document.body.appendChild(anchor);
    	anchor.click();
    	wasFileDownloaded = true;
    	anchor.parentNode.removeChild(anchor);
  	}



</script>

<div class="newBatchImportContainer">
	

	<div class="inputCol">

		<div class="inputContainer">

			<div class="fileTypeTitle">Product</div>

			<select bind:value={productSelected} class="formInput formSelect" id="selectProduct" name="selectProduct">
				<option class="formInputOption" value="Select">Select</option>
				{#if productsArray != null}
					{#each productsArray as product}
						<option class="formInputOption" value={product.name}>{product.name}</option>
					{/each}
				{/if}

			</select>
		
		</div>

		<div class="inputContainer">

			<div class="fileTypeTitle">Choose the file type</div>

			<select bind:value={fileTypeSelected} class="formInput formSelect" id="selectFile" name="selectFile">
				<option class="formInputOption" value="Select" selected >Select</option>
			    <option class="formInputOption" value="Excel">Excel</option>
			    <option class="formInputOption" value="CSV">CSV</option>
			</select>
			
		
		</div>

		<div class="inputContainer">

			<div class="fileTypeTitle">Data type</div>

			<select bind:value={dataType} class="formInput formSelect" id="selectFile" name="selectFile">
				<option class="formInputOption" value="Select" selected >Select</option>
			    <option class="formInputOption" value="Mean">Import mean values</option>
			    <option class="formInputOption" value="Individual">Import individual values per sample</option>
			</select>
			
		
		</div>

	</div>

	<div class="inputCol">
		{#if fileTypeSelected == "Select" || dataType == "Select"}
			
		{:else}
				<div class="inputContainer">
					<div class="fileTypeTitle">Download {fileTypeSelected} type file</div>

					<div class="downloadBtn" on:click={() => downloadFunc()}> Download file </div>	
					
				</div>	

				{#if wasFileDownloaded}
					<div class="inputContainer">
						<div class="fileTypeTitle">Import file</div>

						<input on:change={(e)=> getFile(e)} class="formInput" type="file" name="fileImport">	
						
					</div>
				{:else}
					<div class="inputContainer">
						<div class="fileTypeTitle">Import file</div>

						<input on:change={(e)=> getFile(e)} class="formInput" type="file" name="fileImport" disabled>	
						
					</div>
				{/if}
				

				{#if file != null}


					<div class="inputContainer">

						{#if resExcelFile == null}
							<div class="submitBtnContainer"> 
								<div class="submitBtn">
									<div>Parsing File</div> <div class="loadIcon"><i class="fa-solid fa-spinner"></i></div>
								</div>
							</div>
						{:else}
							<div class="submitBtnContainer"> 
								<div class="submitBtn" on:click={()=> submitDataFromFile()}>
									Upload Data
								</div>
							</div>
						{/if}

							
					</div>
				{/if}

			
		{/if}
	</div>
	

</div>





<style>
	
	.newBatchImportContainer{
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: row;
		justify-content: flex-end;
		/*align-items: flex-start;*/
		margin-top: 5%;

	}

	.inputCol{
		width: 50%;
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
		gap: 10%;
		/*background-color: red;*/
	}

	.inputCol:nth-child(1){
		/*background-color: darkred;*/
	}

	.inputCol:nth-child(2){
		/*background-color: green;*/
	}


	.inputContainer{
		width: 100%;
		height: 15%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
		/*background-color: orange;*/
		gap:10%;
	}

	.fileTypeTitle{
		width: 50%;
		height: 20%;
		color: black;
		font-size: 1.171875vw;
		font-weight: 700;
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}




	.fileActions{
		width: 50%;
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
		/*background-color: orange;*/
		gap:10%;	
	}

	.fileUploadContainer{
		width: 100%;
		height: 50%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap:10%;
	}

	.fileSubmitDataContainer{
		width: 100%;
		height: 20%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.submitBtnContainer{
		width: 50%;
		height: 5.54016620498615vh;
		background-color: transparent;
		color: black;
		font-size: 0.9114583333333334vw;
		font-weight: 700;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		margin-top: 5.2%;
	}

	.loadIcon{
		scale:1.2;
		animation: loader 0.5s infinite;
	}

	@keyframes loader {
	  0% {
	    rotate: 0deg;
	  }
	  100% {
	    rotate: 360deg;
	  }
	}



	.submitBtn{
		width: 50%;
		height: 100%;
		border: 1px solid white;
		border-radius: 3px;
		color: black;
		font-size: 0.9114583333333334vw;
		font-weight: 700;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: row;
		gap: 10%;
		box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.2); 
		transform: translateY(-5px);

	}



	.submitBtn:hover{
		box-shadow: inset -4px -4px 4px rgba(255, 255, 255, 0.2), 
           inset 4px 4px 4px rgba(70, 70, 70, 0.3);
		transform: translateY(0px);
	}

	.downloadBtn{
		width: 50%;
		height: 5.54016620498615vh;
		border: 1px solid white;
		border-radius: 3px;
		background-color: transparent;
		color: black;
		font-size: 0.9114583333333334vw;
		font-weight: 700;
		display: flex;
		align-items: center;
		justify-content: center;
		box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.2); 
		transform: translateY(-5px);
	}

	.downloadBtn:hover{
		box-shadow: inset -4px -4px 4px rgba(255, 255, 255, 0.2), 
           inset 4px 4px 4px rgba(70, 70, 70, 0.3);
		transform: translateY(0px);
	}

	.formInput{
		width: 50%;
		height: 5.54016620498615vh;
		border: 1px solid white;
		border-radius: 3px;
		background-color: transparent;
		color: black;
		font-size: 0.9114583333333334vw;
		font-weight: 700;
		opacity: 1;
		box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.2); 
		transform: translateY(-5px);

	}


	.formSelect{      
		-webkit-box-sizing: border-box;
		-moz-box-sizing: border-box;
		box-sizing: border-box;
		-webkit-appearance: auto;
		-moz-appearance: auto;
		background-color: transparent;
		display: flex;
		align-items: flex-start;
		justify-content: flex-start;
	}


	.formInputOption{
		width: 100%;
		height: 33.333333%;
		background-color: white;
		border: 1px solid white;
		border-radius: 3px;
		color: black;
		font-size: 0.9114583333333334vw;
		font-weight: 700;
	}

	


</style>